export const getDaysSince = (target_date: string) => {
  const diffMs = Date.now() - new Date(target_date).getTime();
  return Math.floor(Math.max(diffMs / (1000 * 60 * 60 * 24), 0));
};

export const dateToDaysAgoString = (base_date: string) => {
  const daysAgo = getDaysSince(base_date);
  if (daysAgo === 0) {
    return 'today';
  } else if (daysAgo === 1) {
    return '1 day ago';
  } else {
    return `${daysAgo} days ago`;
  }
};

export const formatDateStr = (date: Date) => {
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const localCalendarDateToApiDatetime = (date: Date): string => {
  const y = date.getFullYear();
  const m = date.getMonth();
  const d = date.getDate();
  return new Date(Date.UTC(y, m, d, 12, 0, 0, 0)).toISOString();
};
